import { Card, Col, Descriptions, Form, Row, Spin } from 'antd';
import { generalLanguageKeys } from 'config/consts';
import { routerService } from 'core/services';
import { MenuReport } from 'models/MenuReport';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import FileTemplateTable from '../MenuReportDetail/FileTemplateTable/FileTemplateTable';
import { menuReportRepository } from '../MenuReportRepository';
import './MenuReportPreview.scss';
import { Helmet } from 'react-helmet';

export default function MenuReportPreview() {
  const [menuReport, setMenuReport] = useState<MenuReport>(new MenuReport());
  const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams();
  const [translate] = useTranslation();

  React.useEffect(() => {
    setLoading(true);
    menuReportRepository
      .get(id)
      .then(res => {
        setMenuReport(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);
  const [handleGoBack] = routerService.useGoBack();
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${menuReport?.menu?.name} preview - eProcurement Management`}</title>
      </Helmet>
      <div className="page detail-page menu-report-preview ">
        <Spin spinning={loading}>
          <Card
            title={
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start">
                  <button
                    className="btn btn-link btn-back"
                    onClick={handleGoBack}
                  >
                    <i className="fa fa-chevron-left"></i>
                  </button>
                  <div className="pt-1 pl-1">
                    {translate('general.detail.title')}
                  </div>
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-outline-primary float-right ml-2 mr-2"
                    onClick={handleGoBack}
                  >
                    <i className="fa mr-2 fa-times-circle" />
                    {translate(generalLanguageKeys.actions.cancel)}
                  </button>
                </div>
              </div>
            }
          >
            <Form>
              <Descriptions column={4}>
                <Descriptions.Item label={translate('menuReports.menu')}>
                  {menuReport?.menu?.name}
                </Descriptions.Item>
                <Descriptions.Item label={translate('menuReports.name')}>
                  {menuReport?.name}
                </Descriptions.Item>
              </Descriptions>
              <Row>
                <Col lg={6}></Col>
                <Col lg={24}>
                  <FileTemplateTable
                    model={menuReport}
                    setModel={setMenuReport}
                    field={'fileTemplates'}
                    isPreview={true}
                  />
                </Col>
              </Row>
            </Form>
          </Card>
        </Spin>
      </div>
    </>
  );
}
